import { useEffect, useRef, useState } from 'react';
import { chooseOption, type LayerOverrides, type OptionGroup } from '../render/layers';

export function LayerSwitcher({ groups, overrides, onChange }: { groups: OptionGroup[]; overrides: LayerOverrides; onChange(o: LayerOverrides): void }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  if (groups.length === 0) return null;
  const current = (g: OptionGroup) => g.layers.find((l) => overrides[l.id] ?? l.visible)?.id ?? g.defaultLayerId;
  return (
    <div className="rel" ref={ref}>
      <button className={`btn sm${open ? ' on' : ''}`} onClick={() => setOpen((o) => !o)} aria-haspopup="true" aria-expanded={open}>Creative options</button>
      {open && (
        <div className="popover" role="dialog">
          {groups.map((g) => (
            <div key={g.key} style={{ marginBottom: 8 }}>
              <h3>{g.label}</h3>
              {g.layers.map((l) => (
                <label key={l.id} className="opt">
                  <input type="radio" name={`opt-${g.key}`} checked={current(g) === l.id} onChange={() => onChange(chooseOption(g, l.id, overrides))} />
                  <span>{l.name}</span>
                  {l.id === g.defaultLayerId && <span className="muted small">(in draft)</span>}
                </label>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
